import React from 'react';
import Modal from "ui/material-kit/Modal";
import styled from 'styled-components';
import {ReactComponent as CrossIcon} from 'assets/images/input/input_cross_icon.svg'
import {useTypedDispatch, useTypedSelector} from "hooks/useTypedRedux";
import HeaderOne from "../customText/headers/HeaderOne";
import HeaderOneMobile from "../customText/headers/HeaderOne.mobile";
import {selectIsMobile} from "../../redux/selectors/appSelector";


type CustomModalProps = {
    isDesktop?: boolean,
    children: React.ReactNode,
    open: boolean,
    updateOpen: () => { payload: undefined, type: string },
    styles?: any,
    closeIcon?: boolean,
    title?: string
    titleStyle?: any
    outsideClickId?: string
}

const CustomModal = ({
                         children,
                         isDesktop,
                         open,
                         updateOpen,
                         styles,
                         closeIcon = true,
                         title,
                         titleStyle,
                         outsideClickId
                     }: CustomModalProps): JSX.Element => {

    const dispatch = useTypedDispatch()

    const handleClose = () => {
        dispatch(updateOpen())
    }

    const isMobile = useTypedSelector(selectIsMobile)

    return (
        <>
            <Modal
                open={open}
                isFullScreen={isDesktop}
                onClose={handleClose}
                outsideClickId={outsideClickId}>
                <Background style={styles}>
                    <HeaderModal isMobile={isMobile} style={titleStyle}>

                        {title && <>
                            {isMobile
                                ? <TitleMobile>
                                    {title || ' '}
                                </TitleMobile>
                                : <Title>
                                    {title}
                                </Title>
                            }
                        </>}
                        {closeIcon && <IconContainer isMobile={isMobile}>
                            <ExitIcon onClick={handleClose}>
                                <CrossIcon/>
                            </ExitIcon>
                        </IconContainer>}
                    </HeaderModal>


                    {children}
                </Background>
            </Modal>
        </>
    );
};

export default CustomModal;

const Background = styled.div`
  position: relative;
  background: ${({theme}) => theme.palette.background.modal};
  opacity: 1;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  z-index: 10000;
  border: 1px solid ${({theme}) => theme.palette.border.secondary};
  box-shadow: ${({theme}) => theme.palette.shadow.modal};
`

const Title = styled(HeaderOne)`
  text-transform: uppercase;
  color: ${({theme}) => theme.palette.color.main};
  max-width: 250px;
  text-align: center;
`

const TitleMobile = styled(HeaderOneMobile)`
  text-transform: uppercase;
  color: ${({theme}) => theme.palette.color.main};
  max-width: 200px;
  text-align: center;
`

const HeaderModal = styled.div<{ isMobile?: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({isMobile}) => isMobile ? '25px 0' : '50px 0 0'};
`

const IconContainer = styled.div<{ isMobile?: boolean }>`
  position: absolute;
  right: ${({isMobile}) => isMobile ? '10px' : '20px'};
  top: ${({isMobile}) => isMobile ? '10px' : '20px'};
`


const ExitIcon = styled.div`
  position: relative;
  width: 16px;
  height: 16px;
  margin-bottom: 0;
  cursor: pointer;

  & > svg > path {
    stroke: ${({theme}) => theme.palette.svg.main};
  }
`
